import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { useDroppable } from '@dnd-kit/core';

import styles from './styles.module.scss';

const CardDroppable = ({ id, children, borderType, data }) => {
	const { setNodeRef, isOver, over, active } = useDroppable({
		id,
		data
	});

	const isOverOtherCards =
		isOver && over && active && data?.activeId !== active.id;

	return (
		<div
			ref={setNodeRef}
			className={cx(
				styles.MatchingsCard,
				styles.MatchingsCard_type_drop,
				styles[`MatchingsCard_borderType_${borderType}`]
			)}
			style={{ opacity: isOverOtherCards ? 0.8 : 1 }}
		>
			<div className={styles.MatchingsCard__Droppable}>{children}</div>
		</div>
	);
};

CardDroppable.propTypes = {
	id: PropTypes.string,
	children: PropTypes.node,
	borderType: PropTypes.string,
	data: PropTypes.object
};

export default CardDroppable;
